import { Pipe, PipeTransform } from '@angular/core';

import {
  EditProductStructure,
  ProductStructure,
  EditTerm,
  hasSingleTerm
} from '@features/opportunities/models/product-selection/product-selection.model';
import {
  isBridgingProduct,
  isReverseMortgage
} from '@shared/utilities/product/product-feature.util';

@Pipe({
  name: 'filterProductTerms',
  pure: true
})
export class FilterProductTermsPipe implements PipeTransform {
  transform(
    structure: EditProductStructure | ProductStructure,
    features: string[] | { value?: string[] } | null | undefined,
    isEditStructure: boolean = true
  ): EditTerm[] | any[] {
    if (!structure) return [];

    let terms: any[] = [];

    if (isEditStructure) {
      // EditProductStructure: Use hasSingleTerm function
      const editStructure = structure as EditProductStructure;
      if (hasSingleTerm(editStructure)) {
        terms.push(editStructure.singleTerm);
      } else {
        terms.push(editStructure.multiTerm.initialTerm);
        // Hide revert term for bridging products and reverse mortgages
        if (!isBridgingProduct(features) && !isReverseMortgage(features)) {
          terms.push(editStructure.multiTerm.revertTerm);
        }
      }
    } else {
      // ProductStructure: Use direct property checks
      if (structure.singleTerm && structure.singleTerm.rate != null) {
        terms.push(structure.singleTerm);
      } else if (structure.multiTerm) {
        terms.push(structure.multiTerm.initialTerm);
        // Hide revert term for bridging products and reverse mortgages
        if (!isBridgingProduct(features) && !isReverseMortgage(features)) {
          terms.push(structure.multiTerm.revertTerm);
        }
      }
    }

    return terms;
  }
}
